<template>
  <div class="progress-circle-wrapper">
    <div class="outer-circle-container">
      <circle-progress
        ref="vueCircleActivity"
        v-bind="activityCircleProps"
        :class="progressBarClass"
      />
    </div>
    <div v-if="isShowPresenceParticipation" class="inner-circle-container">
      <circle-progress
        ref="vueCirclePresence"
        v-bind="presenceCircleProps"
        class="inner-circle"
      />
    </div>
  </div>
</template>

<script>
import CircleProgress from 'vue3-circle-progress'
import 'vue3-circle-progress/dist/circle-progress.css'

export default {
  name: 'ProgressCircle',
  components: {
    CircleProgress
  },
  props: {
    activityPercentage: {
      type: Number,
      default: 0
    },
    presencePercentage: {
      type: Number,
      default: 0
    },
    isShowPresenceParticipation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentWindowSize: window.innerWidth,
      currentActivityProgress: 0,
      currentPresenceProgress: 0,
      baseCircleProps: {
        lineCap: 'round',
        emptyColor: 'rgba(192, 192, 192, 0.3)',
        transition: 1000,
        viewport: true,
        angle: 11,
        animationDuration: 1000
      }
    }
  },
  computed: {
    isSmallMobile () {
      return this.currentWindowSize <= 452
    },
    activityCircleProps () {
      return {
        percent: this.currentActivityProgress,
        size: this.isSmallMobile ? 24 : 40,
        borderWidth: this.isSmallMobile ? 4 : 5,
        borderBgWidth: this.isSmallMobile ? 4 : 5,
        fillColor: '#006AD3', // royal-navy-500
        showPercent: !this.isSmallMobile && !this.isShowPresenceParticipation,
        ...this.baseCircleProps
      }
    },
    presenceCircleProps () {
      return {
        percent: this.currentPresenceProgress,
        size: this.isSmallMobile ? 12 : 21,
        borderWidth: this.isSmallMobile ? 3 : 5,
        borderBgWidth: this.isSmallMobile ? 3 : 5,
        fillColor: '#39B58F', // eucalyptus-600
        showPercent: false,
        ...this.baseCircleProps
      }
    },
    progressBarClass () {
      return {
        'hide-percentage-text': this.isShowPresenceParticipation
      }
    }
  },
  methods: {
    updateActivityProgress (value) {
      this.currentActivityProgress = value
    },
    updatePresenceProgress (value) {
      this.currentPresenceProgress = value
    },
    handleResize () {
      this.currentWindowSize = window.innerWidth
    }
  },
  watch: {
    activityPercentage: {
      immediate: true,
      handler (value) {
        this.currentActivityProgress = value
      }
    },
    presencePercentage: {
      immediate: true,
      handler (value) {
        this.currentPresenceProgress = value
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    // Set initial progress
    this.currentActivityProgress = this.activityPercentage
    this.currentPresenceProgress = this.presencePercentage
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
.progress-circle-wrapper {
  position: relative;
  width: 24px;
  height: 24px;
}

.progress-circle-wrapper :deep(svg) {
  vertical-align: baseline!important;
}

.outer-circle-container,
.inner-circle-container{
  position: absolute;
}

.inner-circle-container {
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Override inner circle styles */
// :deep(.inner-circle svg) {
  // position: static !important;
  // transform: rotate(-90deg) !important;
// }

:deep(.current-counter) {
  font-weight: 700;
  font-size: 10px;
  color: var(--color-ui-element-navy-500);

  &::after {
    content: "%";
  }
}

.hide-percentage-text :deep(.current-counter) {
  display: none;
}

@media (min-width: 453px) {
  .progress-circle-wrapper {
    width: 40px;
    height: 40px;
  }

  /* Override inner circle styles */
  // :deep(.inner-circle) {
    // position: static !important;
    // height: auto !important;
    // width: 21px !important;
  // }
}
</style>
